import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=2bb435dd&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=2bb435dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb435dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb435dd')) {
      api.createRecord('2bb435dd', component.options)
    } else {
      api.reload('2bb435dd', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=2bb435dd&scoped=true&", function () {
      api.rerender('2bb435dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cOHALZWSULwj/JS/comp/CookieBox.vue"
export default component.exports